import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M66.13 37.72C66.13 36.72 65.64 35.84 64.89 35.31C65.64 34.78 66.13 33.9 66.13 32.9C66.13 31.81 65.54 30.86 64.67 30.35C65.31 29.81 65.72 29.01 65.72 28.1C65.72 26.87 64.98 25.82 63.94 25.38C64.45 24.85 64.76 24.13 64.76 23.33C64.76 21.95 63.83 20.81 62.57 20.48C62.97 19.97 63.22 19.34 63.22 18.64C63.22 17.11 62.06 15.86 60.59 15.72C60.74 15.36 60.83 14.97 60.83 14.56C60.83 12.93 59.53 11.61 57.92 11.61C57.8 11.61 57.69 11.63 57.58 11.64C57.61 11.46 57.64 11.27 57.64 11.08C57.64 9.45002 56.34 8.13 54.73 8.13C54.43 8.13 54.14 8.19003 53.86 8.28003C53.69 6.82003 52.47 5.67999 50.98 5.67999C50.51 5.67999 50.07 5.80001 49.67 6.01001C49.37 4.71001 48.22 3.72998 46.84 3.72998C46.25 3.72998 45.7 3.91003 45.24 4.22003C44.88 3.01003 43.78 2.13 42.47 2.13C41.77 2.13 41.14 2.39 40.64 2.81C40.15 1.88 39.19 1.23999 38.08 1.23999C37.27 1.23999 36.54 1.58 36.01 2.12C35.49 1.61 34.78 1.28998 34 1.28998C33.98 1.28998 33.97 1.29999 33.95 1.29999C33.93 1.29999 33.92 1.28998 33.9 1.28998C33.12 1.28998 32.41 1.61 31.89 2.12C31.36 1.58 30.63 1.23999 29.82 1.23999C28.71 1.23999 27.75 1.88 27.26 2.81C26.76 2.39 26.12 2.13 25.43 2.13C24.12 2.13 23.02 3.02003 22.66 4.22003C22.2 3.91003 21.65 3.72998 21.06 3.72998C19.68 3.72998 18.53 4.70001 18.23 6.01001C17.84 5.81001 17.4 5.67999 16.92 5.67999C15.43 5.67999 14.22 6.82003 14.04 8.28003C13.76 8.19003 13.48 8.13 13.17 8.13C11.56 8.13 10.26 9.45002 10.26 11.08C10.26 11.27 10.28 11.46 10.32 11.64C10.21 11.63 10.1 11.61 9.97998 11.61C8.36998 11.61 7.07001 12.93 7.07001 14.56C7.07001 14.97 7.15 15.37 7.31 15.72C5.84 15.87 4.67999 17.11 4.67999 18.64C4.67999 19.34 4.93002 19.98 5.33002 20.48C4.07002 20.81 3.14001 21.95 3.14001 23.33C3.14001 24.13 3.46002 24.85 3.96002 25.38C2.91002 25.83 2.17999 26.88 2.17999 28.1C2.17999 29.01 2.58998 29.81 3.22998 30.35C2.35998 30.86 1.77002 31.8 1.77002 32.9C1.77002 33.9 2.26001 34.78 3.01001 35.31C2.26001 35.84 1.77002 36.72 1.77002 37.72C1.77002 38.75 2.30003 39.66 3.09003 40.19C2.62003 40.72 2.32001 41.41 2.32001 42.18C2.32001 43.78 3.58001 45.08 5.14001 45.12C5.66001 47.83 6.20001 49.46 6.20001 49.46L15.88 19.16C15.88 19.16 25.68 17.51 33.95 17.47C42.22 17.5 52.02 19.16 52.02 19.16L61.7 49.46C61.7 49.46 62.24 47.83 62.76 45.12C64.33 45.07 65.58 43.78 65.58 42.18C65.58 41.41 65.28 40.72 64.81 40.19C65.6 39.66 66.13 38.75 66.13 37.72Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M33.79 16.98C33.79 16.98 30.57 10.6201 22.23 4.59009"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M17.03 6.12012C17.03 6.12012 21.82 8.10014 29.58 17.0201"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M13.8401 8.68005C13.8401 8.68005 18.3501 10.5001 25.3701 17.6801"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M10.4299 11.98C10.4299 11.98 15.7999 13.55 20.9199 18.26"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M7.20996 15.9501C7.20996 15.9501 11.3399 16.3601 16.3799 19.0101"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M14.72 22.0601C14.72 22.0601 9.34997 20.8201 5.46997 20.9901"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M13.6501 26.2702C13.6501 26.2702 7.95007 25.5301 4.07007 25.6901"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M12.41 30.23C12.41 30.23 7.29008 29.57 3.08008 30.31"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M11.09 34.61C11.09 34.61 7.21 34.57 3 35.31" stroke={outline} strokeWidth="0.75" strokeMiterlimit="10" />
      <path d="M9.84991 38.16L3.15991 40.4701" stroke={outline} strokeWidth="0.75" strokeMiterlimit="10" />
      <path
        d="M34 17.0401C34 17.0401 37.22 10.6801 45.56 4.65015"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M41.7802 2.71008C41.7802 2.71008 37.8201 5.52005 33.9401 11.3H33.9801C30.1001 5.52005 26.1401 2.71008 26.1401 2.71008"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M50.6799 6.12012C50.6799 6.12012 45.8899 8.10014 38.1299 17.0201"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M53.8701 8.68005C53.8701 8.68005 49.3601 10.5001 42.3401 17.6801"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M57.29 11.98C57.29 11.98 51.92 13.55 46.8 18.26"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M37.39 1.58008C37.39 1.58008 35.39 3.29006 33.9 5.69006C32.41 3.30006 30.49 1.58008 30.49 1.58008"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M60.5101 15.9501C60.5101 15.9501 56.3801 16.3601 51.3401 19.0101"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M52.99 22.0601C52.99 22.0601 58.36 20.8201 62.24 20.9901"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M54.0701 26.2702C54.0701 26.2702 59.7701 25.5301 63.6501 25.6901"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M55.3 30.23C55.3 30.23 60.4201 29.57 64.6301 30.31"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M56.6299 34.61C56.6299 34.61 60.5098 34.57 64.7198 35.31"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M57.8599 38.16L64.5499 40.4701" stroke={outline} strokeWidth="0.75" strokeMiterlimit="10" />
    </g>
  )
}
